module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-light-webfont.14025e71.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-light-webfont.eot
// module id = 95
// module chunks = 3